export default __webpack_public_path__ + "assets/facebook-square.e7dae8ad.svg";